// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "95d06213167b81a64ef9b6a87ff58fd9146894e7/static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"83cd5b92","98":"c3469f9b","157":"a30c2714","215":"28b12c6b","777":"dfb468f1","861":"8661553f","952":"1030e47e"}[chunkId] + ".chunk.js";
};